import { LmViewer3D } from "@/types/LmViewer3D/LmViewer3D";
import { gridFilteredSortedRowEntriesSelector } from "@mui/x-data-grid-premium";
import { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";
import { MutableRefObject, useEffect } from "react";

export interface UseLmViewerSyncProps {
  apiRef: MutableRefObject<GridApiPremium>;
  lmViewer?: LmViewer3D;
}

const useLmViewerSync = (props: UseLmViewerSyncProps) => {
  console.log("useLmViewerSync -> props: ", props);
  const { apiRef, lmViewer } = props;

  useEffect(() => {
    const handleAggregateSelectionChanged = async (event: any) => {
      console.log("handleAggregateSelectionChanged: ", event);
      lmViewer?.getCadIdsFromSelections(event.selections).then((modelToCadIdMap: Map<string, Set<string>>) => {
        console.log("cadIds: ", modelToCadIdMap);

        // cadIds
        const cadIds = modelToCadIdMap.values().reduce((acc: string[], cadIds: Set<string>) => {
          acc.push(...Array.from(cadIds));
          return acc;
        }, []);

        if (cadIds.length === 0) {
          apiRef.current.selectRows([], true, true);
        } else {
          const rows = gridFilteredSortedRowEntriesSelector(apiRef!);
          const rowIds = [];
          for (const row of rows) {
            const cadId = (row as any)?.model?.data?.cadId;
            if (cadId && cadIds.includes(cadId)) {
              rowIds.push(row.id);
            }
          }
          apiRef.current.selectRows(rowIds, true, true);
        }
      });
    };

    if (lmViewer) {
      lmViewer.emitter.on(Autodesk.Viewing.AGGREGATE_SELECTION_CHANGED_EVENT, handleAggregateSelectionChanged);
    }
    return () => {
      if (lmViewer) {
        lmViewer.emitter.off(Autodesk.Viewing.AGGREGATE_SELECTION_CHANGED_EVENT, handleAggregateSelectionChanged);
      }
    };
  }, [apiRef, lmViewer]);

  useEffect(() => {
    const handleAggregateIsolationChanged = async (event: any) => {
      console.log("handleAggregateIsolationChanged: ", event);
      lmViewer?.getCadIdsFromIsolations(event.isolation).then((modelToCadIdMap: Map<string, Set<string>>) => {
        console.log("cadIds: ", modelToCadIdMap);

        // cadIds
        const cadIds = modelToCadIdMap.values().reduce((acc: string[], cadIds: Set<string>) => {
          acc.push(...Array.from(cadIds));
          return acc;
        }, []);

        if (cadIds.length === 0) {
          apiRef.current.deleteFilterItem({ field: "cadId", operator: "isAnyOf" });
        } else {
          apiRef.current.setFilterModel({ items: [{ field: "cadId", operator: "isAnyOf", value: cadIds }] });
        }
      });
    };

    if (lmViewer) {
      lmViewer.emitter.on(Autodesk.Viewing.AGGREGATE_ISOLATION_CHANGED_EVENT, handleAggregateIsolationChanged);
    }
    return () => {
      if (lmViewer) {
        lmViewer.emitter.off(Autodesk.Viewing.AGGREGATE_ISOLATION_CHANGED_EVENT, handleAggregateIsolationChanged);
      }
    };
  }, [apiRef, lmViewer]);

  useEffect(() => {
    const handleIsolateChanged = async (event: any) => {
      console.log("handleIsolateChanged: ", event);
    };

    if (lmViewer) {
      lmViewer.emitter.on(Autodesk.Viewing.ISOLATE_EVENT, handleIsolateChanged);
    }
    return () => {
      if (lmViewer) {
        lmViewer.emitter.off(Autodesk.Viewing.ISOLATE_EVENT, handleIsolateChanged);
      }
    };
  }, [lmViewer]);

  useEffect(() => {
    const handleShowAllChanged = async (event: any) => {
      console.log("handleShowAllChanged: ", event);
    };

    if (lmViewer) {
      lmViewer.emitter.on(Autodesk.Viewing.SHOW_ALL_EVENT, handleShowAllChanged);
    }
    return () => {
      if (lmViewer) {
        lmViewer.emitter.off(Autodesk.Viewing.SHOW_ALL_EVENT, handleShowAllChanged);
      }
    };
  }, [lmViewer]);

  useEffect(() => {
    const handleShowChanged = async (event: any) => {
      console.log("handleShowChanged: ", event);
    };

    if (lmViewer) {
      lmViewer.emitter.on(Autodesk.Viewing.SHOW_EVENT, handleShowChanged);
    }
    return () => {
      if (lmViewer) {
        lmViewer.emitter.off(Autodesk.Viewing.SHOW_EVENT, handleShowChanged);
      }
    };
  }, [lmViewer]);

  useEffect(() => {
    const handleHideAllChanged = async (event: any) => {
      console.log("handleHideAllChanged: ", event);
    };

    if (lmViewer) {
      lmViewer.emitter.on(Autodesk.Viewing.HIDE_ALL_EVENT, handleHideAllChanged);
    }
    return () => {
      if (lmViewer) {
        lmViewer.emitter.off(Autodesk.Viewing.HIDE_ALL_EVENT, handleHideAllChanged);
      }
    };
  }, [lmViewer]);

  useEffect(() => {
    const handleHideChanged = async (event: any) => {
      console.log("handleHideChanged: ", event);
    };

    if (lmViewer) {
      lmViewer.emitter.on(Autodesk.Viewing.HIDE_EVENT, handleHideChanged);
    }
    return () => {
      if (lmViewer) {
        lmViewer.emitter.off(Autodesk.Viewing.HIDE_EVENT, handleHideChanged);
      }
    };
  }, [lmViewer]);
};

export default useLmViewerSync;
